var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',{staticClass:"py-4 card"},[_c('h3',[_vm._v("Website copy")]),_c('p',[_vm._v("Tips on your website copy")])])}
var staticRenderFns = []

export { render, staticRenderFns }